// src/components/store/sections/testimonials/TestimonialV82CardsliderCoralFlame.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV82CardsliderCoralFlame(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={82}
      archKey="card_slider"
      archLabel="Review Card Carousel"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f97316"
      {...props}
    />
  );
}
